// @see https://xml.insee.fr/schema/cj-enum.html

interface LegalStatusForInseeMatching {
  readonly inseeCode: string;
}

export const matchLegalStatusFromNatureJuridique = <
  T extends LegalStatusForInseeMatching,
>(
  natureJuridique: string | null | undefined,
  legalStatuses: readonly T[],
): T | undefined =>
  natureJuridique
    ? legalStatuses.find(
        (legalStatus) => legalStatus.inseeCode === natureJuridique,
      )
    : undefined;
